<template>
	<div
		:class="['notification-icon', classVariation]"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<i :class="['icon', iconVariation]" data-test="icon" />
	</div>
</template>

<script>
export default {
	name: 'NotificationIcon',

	props: {
		variant: {
			type: String,
			default: 'neutral'
		}
	},
	computed: {
		iconClassVariation() {
			const iconClassVariations = {
				positive: {
					icon: 'icon-positive-solid',
					class: 'notification-icon--positive'
				},
				negative: {
					icon: 'icon-error-solid',
					class: 'notification-icon--negative'
				},
				warning: {
					icon: 'icon-warning-solid',
					class: 'notification-icon--warning'
				},
				inactive: {
					icon: 'icon-indeterminate-solid',
					class: 'notification-icon--inactive'
				},
				'not-allowed': {
					icon: 'icon-not-allowed',
					class: 'notification-icon--not-allowed'
				},
				'neutral-inactive': {
					icon: 'icon-info-solid',
					class: 'notification-icon--neutral-inactive'
				},
				corrupted: {
					icon: 'icon-error-solid',
					class: 'notification-icon--corrupted'
				},
				default: {
					icon: 'icon-info-solid',
					class: 'notification-icon--neutral'
				}
			};
			return (
				iconClassVariations[this.variant] || iconClassVariations.default
			);
		},
		classVariation() {
			return this.iconClassVariation.class;
		},
		iconVariation() {
			return this.iconClassVariation.icon;
		}
	}
};
</script>

<style lang="scss">
/**
    * Notification Icon - Reusable icon for elements
*/

.notification-icon {
	display: inline-flex;
	@include create-circle(18px, 18px, $ui-neutral);
	justify-content: center;
	align-items: center;
	@include text-contrast($ui-neutral, $white, $black);
	font-weight: $medium-font-weight;
	font-size: $default-font-size + 2;

	&--neutral {
		background-color: transparent;
		.icon {
			color: $ui-neutral;
		}
		&-inactive {
			background-color: transparent;
			.icon {
				color: $neutral-3;
			}
		}
	}

	&--positive {
		background-color: transparent;
		.icon {
			color: $ui-positive;
		}
	}

	&--negative {
		background-color: transparent;
		.icon {
			color: $ui-negative;
		}
	}

	&--warning {
		background-color: transparent;
		.icon {
			color: $ui-warning;
		}
	}

	&--inactive {
		background-color: transparent;
		.icon {
			color: $neutral-3;
		}
	}
	&--corrupted,
	&--not-allowed {
		background-color: transparent;
		.icon {
			color: $ui-negative;
		}
	}
}
</style>
